import { t } from "@redotech/redo-i18n";
import { ExternalShipmentTracker } from "./trackable";

export const prettyTrackerStatus: Record<
  ExternalShipmentTracker["status"],
  string
> = {
  unknown: "Unknown",
  pre_transit: "Pre-transit",
  in_transit: "In transit",
  out_for_delivery: "Out for delivery",
  delivered: "Delivered",
  available_for_pickup: "Available for pickup",
  return_to_sender: "Return to sender",
  failure: "Failure",
  cancelled: "Cancelled",
  error: "Error",
  expired: "Expired",
};

export function getPrettyI18nTrackerStatus(): Record<
  ExternalShipmentTracker["status"],
  string
> {
  return {
    unknown: t("Unknown", { context: "shipment status" }),
    pre_transit: t("Pre-transit"),
    in_transit: t("In transit"),
    out_for_delivery: t("Out for delivery"),
    delivered: t("Delivered"),
    available_for_pickup: t("Available for pickup"),
    return_to_sender: t("Return to sender"),
    failure: t("Failure", { context: "shipment status" }),
    cancelled: t("Cancelled"),
    error: t("Error", { context: "shipment status" }),
    expired: t("Expired"),
  };
}

export const shipmentStatusList: Record<
  ExternalShipmentTracker["status"] | "stalled_in_transit",
  string
> = {
  unknown: "Unknown",
  pre_transit: "Pre-transit",
  in_transit: "In transit",
  out_for_delivery: "Out for delivery",
  delivered: "Delivered",
  available_for_pickup: "Available for pickup",
  return_to_sender: "Return to sender",
  failure: "Failure",
  cancelled: "Cancelled",
  error: "Error",
  stalled_in_transit: "Stalled",
  expired: "Expired",
};
